var _rect, _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFlagMaroc(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 17,
    viewBox: "0 0 24 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 16,
    stroke: "#5754E5",
    strokeOpacity: 0.15
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23 1H1V16H23V1Z",
    fill: "url(#paint0_linear_10403_49068)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.9095 11.7918L10.7081 9.27771L8.61719 7.7243H11.2018L12.0009 5.20825L12.7999 7.7243H15.3846L13.2936 9.27771L14.0922 11.7918L12.0009 10.238L9.9095 11.7918ZM12.4107 9.9333L13.1757 10.5016L12.8834 9.5819L12.4107 9.9333ZM11.1179 9.5819L10.8256 10.5016L11.5906 9.9333L11.1179 9.5819ZM11.2745 9.08937L12.0009 9.6291L12.7272 9.08937L12.4498 8.21683H11.5515L11.2745 9.08937ZM10.1002 8.21683L10.8647 8.7847L11.0452 8.21683H10.1002ZM13.137 8.7847L13.9016 8.21683H12.9566L13.137 8.7847ZM11.7081 7.7243H12.2936L12.0009 6.80313L11.7081 7.7243Z",
    fill: "#00833E"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_10403_49068",
    x1: 1,
    y1: 8.49993,
    x2: 22.9998,
    y2: 8.49993,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CE1A17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CE1A17"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagMaroc);
export default __webpack_public_path__ + "static/media/flagMaroc.ddbf98771403532ee3caf217510b4017.svg";
export { ForwardRef as ReactComponent };